import { isArray } from 'lodash-es';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import util from '../../shared/util';
import TimeLineNode from './components/time-line-node';
import tlp from './deliveryStatus.vue';
@Component({
    name: 'DefaultSelect',
    mixins: [tlp],
    components: {
        TimeLineNode,
    },
    filters: {
        filtersName(value: any, filterKey: any) {
            if (value && value[filterKey]) return value[filterKey];
            else return value;
        },
    },
})
export default class DeliveryStatus extends Vue {
    @Prop({
        default: {},
    })
    propTrackedShipment: any;

    @Prop({
        default: '',
    })
    title: any;

    @Prop({
        default: '',
    })
    orderId: any;

    trackedShipment: any = {};
    deliveryStagesLine: any = 0;
    deliveryStages: any = 0;

    get lineHaulRecords() {
        if (
            !this.trackedShipment.order_line ||
            !this.trackedShipment.order_line.in_transit ||
            !isArray(this.trackedShipment.order_line.in_transit.lh_record)
        ) {
            return [];
        }
        return this.trackedShipment.order_line.in_transit.lh_record;
    }

    @Watch('orderId', { deep: true })
    getOrderId(val: any, oldVal: any) {
        if (this.propTrackedShipment) return;
        else this.getTrackForOrderId(val);
    }

    @Watch('propTrackedShipment', { deep: true })
    getpropTrackedShipment(val: any, oldVal: any) {
        this.trackedShipment = this.propTrackedShipment;
        this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
    }

    mounted() {
        if (this.propTrackedShipment) {
            this.trackedShipment = this.propTrackedShipment;
            this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
        } else this.getTrackForOrderId(this.orderId);
    }

    private getTrackForOrderId(orderId: any) {
        tmsServiceBackend.get(`/cpv2/tracking/track?order_id=${orderId}`).then(
            (res: any) => {
                if (res.data.status == 0) {
                    this.err(res.data.message);
                    return;
                }
                this.trackedShipment = res.data.data[0];
                this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
            },
            (err: any) => {
                this.err(err.response.data.statusText);
            }
        );
    }

    private getProgressImage(shipmentStage: number, shipmentStatus: number) {
        let privateOrderStatus = util.filterShipmentStage(shipmentStage, shipmentStatus);

        if (privateOrderStatus == 'Pickup Created') {
            this.deliveryStages = 5;
            this.deliveryStagesLine = 1;
        }

        if (privateOrderStatus == 'Pickup Dispatched') {
            this.deliveryStages = 1;
            this.deliveryStagesLine = 2;
        }

        if (privateOrderStatus == 'Pickup Completed') {
            this.deliveryStages = 1;
            this.deliveryStagesLine = 3;
        }

        if (privateOrderStatus == 'In Transit') {
            this.deliveryStages = 2;
            this.deliveryStagesLine = 4;
        }

        if (privateOrderStatus == 'Out for Delivery') {
            this.deliveryStages = 3;
            this.deliveryStagesLine = 5;
        }

        if (privateOrderStatus == 'Delivered') {
            this.deliveryStages = 4;
            this.deliveryStagesLine = 6;
        }

        this.$forceUpdate();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/deliveryStatus/index.ts